<div *ngIf="connectionObject">
  <h2>Anschlussobjekt</h2>
  <p fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2em">
    <span style="white-space: nowrap">
      {{ connectionObject.street }} {{ connectionObject.streetNo }}
      {{ connectionObject.streetNoAddition }}
      <br />
      {{ connectionObject.zipCode }} - {{ connectionObject.city }}

      <span *ngIf="connectionObject.developmentAreaName || connectionObject.corridorNumber">
        <br />
        <br />
        <span *ngIf="connectionObject.developmentAreaName">
          Neubaugebiet: {{ connectionObject.developmentAreaName }}
        </span>
        <br />
        <span *ngIf="connectionObject.corridorNumber">
          Flurstücknummer: {{ connectionObject.corridorNumber }}
        </span>
      </span>
    </span>

    <span>
      <mat-chip-listbox *ngIf="connectionObjectAdditionalInfo">
        <!-- Neubau? -->
        <mat-chip-option *ngIf="connectionObjectAdditionalInfo.isNewBuilding">Neubau</mat-chip-option>
        <!-- Gebäudetyp -->
        <mat-chip-option *ngIf="connectionObjectAdditionalInfo.buildingType">
          {{ connectionObjectAdditionalInfo.buildingType | commissioningPowerObjectTypePipe }}
        </mat-chip-option>
        <!-- Anzahl der Wohnungen -->
        <mat-chip-option *ngIf="connectionObjectAdditionalInfo.numberOfFlats">
          {{ connectionObjectAdditionalInfo.numberOfFlats }} Wohnungen
        </mat-chip-option>
        <mat-chip-option *ngIf="connectionObjectAdditionalInfo.numberOfUsers">
          {{ connectionObjectAdditionalInfo.numberOfUsers }} Anschlussnutzer
        </mat-chip-option>
        <mat-chip-option *ngIf="connectionObjectAdditionalInfo.numberOfOtherUsers">
          {{ connectionObjectAdditionalInfo.numberOfOtherUsers }} sonstige Anschlussnutzer
        </mat-chip-option>
        <mat-chip-option *ngIf="connectionObjectAdditionalInfo.objectUsage">
          Nutzungsart: {{ connectionObjectAdditionalInfo.objectUsage }}
        </mat-chip-option>
      </mat-chip-listbox>
    </span>
  </p>
</div>
